<template>
  <CollapsibleCard
    :editable="editable"
    :editing="editing"
  >
    <template v-slot:header> Lärlingsuppgifter </template>

    <template v-slot:info>
      {{ apprentice.firstName }} {{ apprentice.lastName }} ({{ maskedPersonalNumber }}), {{ apprentice.email }},
      {{ apprentice.mobilephone }}
    </template>

    <template v-slot:detailsinfo></template>

    <template v-slot:editinfo> Namn, personnummer, mobilnummer, e-postadress och adress.</template>

    <template v-slot:view>
      <ApplicationApprenticeView
        :apprentice="apprentice"
        :maskedPersonalNumber="maskedPersonalNumber"
      />
    </template>

    <template v-slot:edit>
      <ApplicationApprenticeEdit
        v-model="apprentice"
        ref="edit"
        @save="saved()"
      />
    </template>

    <template v-slot:cancel>
      <v-btn
        color="secondary"
        @click="$refs.edit.cancelChangeApprentice()"
      >
        <v-icon>$sl-cancel</v-icon>Avbryt
      </v-btn>
    </template>

    <template v-slot:save>
      <v-btn
        data-cy="save-application"
        @click="$refs.edit.saveChangeApprentice()"
      >
        <v-icon>$sl-check</v-icon>Spara
      </v-btn>
    </template>
  </CollapsibleCard>
</template>

<script>
import {mapGetters} from 'vuex'
import CollapsibleCard from '@/components/common/CollapsibleCard'
import AddressBox from '@/components/AddressBox'
import pick from 'lodash/pick'
import {RulesMixin} from '@/components/mixins'
import ApplicationApprenticeView from './ApplicationApprenticeView.vue'
import ApplicationApprenticeEdit from './ApplicationApprenticeEdit.vue'

// @group Application
// ApplicationApprentice component
export default {
  name: 'ApplicationApprentice',

  mixins: [RulesMixin],

  props: {
    // Should fields be editable
    editMode: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    }
  },

  components: {
    AddressBox,
    CollapsibleCard,
    ApplicationApprenticeView,
    ApplicationApprenticeEdit
  },

  data: () => ({
    columns: [
      'id',
      'lastName',
      'firstName',
      'personalNumber',
      'address1',
      'address2',
      'zip',
      'city',
      'country',
      'mobilephone',
      'email',
      'state',
      'stateId',
      'isCompanyApplication'
    ],
    apprentice: {},
    editing: null
  }),

  created() {
    if (this.editMode) {
      this.editing = true
    }
  },

  computed: {
    ...mapGetters('application', ['selectedApplication']),

    maskedPersonalNumber() {
      this.apprentice = pick(this.selectedApplication, this.columns)
      if (this.apprentice.personalNumber) {
        const p = this.apprentice.personalNumber
        if (p && p.length > 8) return p.substring(0, 8) + '-****'
        return ''
      }
    }
  },

  methods:{
    saved(){
      this.editing = false
      this.$emit('saved')
    }
  }
}
</script>

<style>
</style>
